/* Home-page behaviors — ported 1:1 from <VaultHero> and <ExclusiveVaultDeal>.
   No-ops when the sections aren't on the page. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Hero carousel ──────────────────────────────────────────────────── */
  document.querySelectorAll("[data-hero]").forEach(function (hero) {
    var slides = hero.querySelectorAll("[data-hero-slide]");
    var media = hero.querySelectorAll("[data-hero-media]");
    var dots = hero.querySelectorAll("[data-hero-dot]");
    var track = hero.querySelector("[data-hero-track]");
    var n = slides.length;
    if (n < 2) return;
    var cur = 0, timer = 0, paused = false;
    var delay = parseInt(hero.getAttribute("data-autoplay"), 10) || 5500;

    function setActive(list, i) {
      list.forEach(function (el, j) { el.classList.toggle("is-active", j === i); });
    }
    function go(i) {
      cur = (i + n) % n;
      setActive(slides, cur); setActive(media, cur);
      dots.forEach(function (d, j) {
        d.classList.toggle("is-active", j === cur);
        d.setAttribute("aria-selected", j === cur ? "true" : "false");
      });
      slides.forEach(function (s, j) {
        if (j === cur) { s.removeAttribute("aria-hidden"); s.removeAttribute("inert"); }
        else { s.setAttribute("aria-hidden", "true"); s.setAttribute("inert", ""); }
      });
      restart();
    }
    function tick() { if (!paused && !reduce) go(cur + 1); }
    function restart() { window.clearInterval(timer); if (!reduce) timer = window.setInterval(tick, delay); }

    dots.forEach(function (d, j) { d.addEventListener("click", function () { go(j); }); });
    var prev = hero.querySelector("[data-hero-prev]"), next = hero.querySelector("[data-hero-next]");
    if (prev) prev.addEventListener("click", function () { go(cur - 1); });
    if (next) next.addEventListener("click", function () { go(cur + 1); });

    hero.addEventListener("mouseenter", function () { paused = true; });
    hero.addEventListener("mouseleave", function () { paused = false; });
    hero.addEventListener("focusin", function () { paused = true; });
    hero.addEventListener("focusout", function (e) { if (!hero.contains(e.relatedTarget)) paused = false; });

    // Touch swipe (touch-action: pan-y keeps vertical scroll native)
    var start = null, swiped = false;
    if (track) {
      track.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse") return;
        start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      });
      track.addEventListener("pointerup", function (e) {
        var t = start; start = null;
        if (!t || e.pointerId !== t.id) return;
        var dx = e.clientX - t.x, dy = e.clientY - t.y;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          swiped = true;
          go(dx < 0 ? cur + 1 : cur - 1);
        }
      });
      track.addEventListener("pointercancel", function () { start = null; });
      track.addEventListener("click", function (e) {
        if (swiped) { swiped = false; e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    restart();
  });

  /* ── Vault shelf — client-side family filter (matches <VaultSection>) ── */
  document.querySelectorAll("[data-shelf]").forEach(function (shelf) {
    var chips = Array.prototype.slice.call(shelf.querySelectorAll("[data-shelf-chips] [data-family]"));
    var grid = shelf.querySelector("[data-shelf-grid]");
    var countEl = shelf.querySelector("[data-shelf-count]");
    if (!grid || !chips.length) return;
    var items = Array.prototype.slice.call(grid.children);

    function apply(fam, label) {
      var shown = 0;
      items.forEach(function (it) {
        var match = fam === "all" || it.getAttribute("data-family") === fam;
        it.hidden = !match;
        it.removeAttribute("data-slot");
        it.style.gridColumn = "";
        it.style.gridRow = "";
        if (match) { shown++; if (it.hasAttribute("data-reveal")) it.classList.add("is-in"); }
      });
      // The 2x2 hero tile is opt-in: only grids marked data-shelf-featured get
      // it, so a plain uniform grid (the collection page) stays uniform.
      if (grid.hasAttribute("data-shelf-featured")) {
        var first = items.filter(function (it) { return !it.hidden; })[0];
        if (first) { first.setAttribute("data-slot", "featured"); first.style.gridColumn = "span 2"; first.style.gridRow = "span 2"; }
      }
      if (countEl) countEl.textContent = label + ": " + shown + (shown === 1 ? " product" : " products");
    }

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var fam = chip.getAttribute("data-family");
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle("td-chip--selected", on);
          c.setAttribute("aria-pressed", on ? "true" : "false");
        });
        apply(fam, chip.querySelector("span").textContent);
        var url = new URL(window.location);
        if (fam === "all") url.searchParams.delete("v"); else url.searchParams.set("v", fam.toLowerCase());
        history.replaceState(null, "", url);
      });
    });

    var v = new URL(window.location).searchParams.get("v");
    if (v) {
      var target = chips.filter(function (c) { return c.getAttribute("data-family").toLowerCase() === v; })[0];
      if (target) target.click();
    }
  });

  /* The exclusive deal's pointer parallax and scroll-progress fallback were
     removed with the floating pack — the product now lives in the plate
     artwork, so there is nothing left to animate. */
})();
